// extracted by mini-css-extract-plugin
export default {"container":"F4Q-w"};